import { render, staticRenderFns } from "./LeadershipCarousel.vue?vue&type=template&id=6d7921c3&scoped=true"
import script from "./LeadershipCarousel.vue?vue&type=script&lang=js"
export * from "./LeadershipCarousel.vue?vue&type=script&lang=js"
import style0 from "./LeadershipCarousel.vue?vue&type=style&index=0&id=6d7921c3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.16_css-loader@6.11.0_webpack@5.99.9__lodash@4._400fd893165f8898ec34f2f453564d40/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d7921c3",
  null
  
)

export default component.exports